module.exports = __webpack_public_path__ + "img/C户型2.6dae8f68.png";